import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NumberViewComponent } from '../../../shared/components/public/numberview.component';
import { DateViewComponent } from '../../../shared/components/public/dateview.component';
import { LocalDataSource } from 'ng2-smart-table';
import { tiens_phieuchi } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-ketoan-dsdinhkhoanmau',
  templateUrl: './dsdinhkhoanmau.component.html',  
    providers: [ListService, Repository]
})


export class dsdinhkhoanmauComponent implements OnInit {

   
    quyen_them: boolean = false;
    quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  primaryColour: string = '#5d9cec';
  secondaryColour: string = '#ff902b';

  public tTuNgay: string;
  public tDenNgay: string;
  public TuNgay: Date = new Date();
  public DenNgay: Date = new Date();

  indLoading: boolean = false;
  
  source: LocalDataSource;
 
   
    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor(  private repo: Repository) {
    }

  ngOnInit(): void {
    this.source = new LocalDataSource();
    }

  settings = {
    mode: 'external',
    
    attr: {
      class: 'table table-striped table-bordered table-hover'
    },
    pager:{
      perPage: 1,
      display: false,
    },
    actions: {
    
      add: false,
      edit: false,
      delete: false,

      position: 'right',
    },
    columns: {

      Ma_Chung_Tu: {
        name: 'Ma_Chung_Tu',
        width: '100px',
        title: 'Mã CT ',

      },
      Ngay_Chung_Tu: {
        name: 'Ngay_Chung_Tu',
        width: '150px',
        title: 'Ngày',
        type: 'custom',
        renderComponent: DateViewComponent,
      },
      Tai_Khoan_No: {
        name: 'Tai_Khoan_No',
        width: '100px',
        title: 'TK Nợ',
      },
      Tai_Khoan_Co: {
        name: 'Tai_Khoan_Co',
        width: '100px',
        title: 'TK Có',
      },
      Dien_Giai_Chi_Tiet: {
        name: 'Dien_Giai_Chi_Tiet',
        width: '200px',
        title: 'Diễn giải',
      },
      So_Tien: {
        name: 'So_Tien',
        title: 'Số tiền',
        width: '100px',
        type: 'custom',
        renderComponent: NumberViewComponent,
      },
      Nguon: {
        name: 'Nguon',
        width: '250px',
        title: 'Nguồn',
      },
      Loai_Khoan: {
        name: 'Loai_Khoan',
        width: '100px',
        title: 'Loại khoản',
      },
      Tieu_Muc: {
        name: 'Tieu_Muc',
        width: '100px',
        title: 'Tiểu mục',
      },
      Khoan_Muc: {
        name: 'Khoan_Muc',
        width: '150px',
        title: 'Nhiệm vụ chi',
      },
      Nghiep_Vu: {
        name: 'Nghiep_Vu',
        width: '150px',
        title: 'Nghiệp vụ',
      },
      Cap_Phat: {
        name: 'Cap_Phat',
        width: '150px',
        title: 'Cấp phát',
      },
     
    },
  };
  khoangthoigian: number = 20;

  donviid: any;
  username: any;
  namketoan: any
  phanheid: any;
  nguonkinhphi: string;

  loadDataInit(tkhoangthoigian: number, tTuNgay: Date, tDenNgay: Date, tdonviid: any, tusername: any, tnamketoan: any, tphanheid: any)
  {
    this.donviid = tdonviid;
    this.username = tusername;
    this.namketoan = tnamketoan;
    this.phanheid = tphanheid;

    this.khoangthoigian = tkhoangthoigian;
    this.TuNgay = tTuNgay;
    this.DenNgay = tDenNgay;
  

    var tngay = (tTuNgay.getMonth() + 1) + '/' + tTuNgay.getDate() + '/' + tTuNgay.getFullYear();
    var dngay = (tDenNgay.getMonth() + 1) + '/' + tDenNgay.getDate() + '/' + tDenNgay.getFullYear();

    this.repo.postRequest("api/chungtu/get_laybangke/", { id: tdonviid, chuoi: this.nguonkinhphi, chuoi1: tusername, status: tnamketoan, chuoi2: tngay, chuoi3: dngay, chuoi4: this.phanheid })
      .subscribe(response => {
        console.log(response);
        
        this.source.load(response);
      });
  }
  
  private loadGrid(tngay: string, dngay: string) {
   

    this.repo.postRequest("api/chungtu/get_laybangke/", { id: this.donviid, chuoi: this.nguonkinhphi, chuoi1: this.username, status: this.namketoan, chuoi2: tngay, chuoi3: dngay, chuoi4: this.phanheid })
      .subscribe(response => {
        console.log(response);
        this.source.load(response);
      });
  }

    keyTenPress(event: any) { 
      
  }
    selectedRows: any;
    onRowSelect(event) {
      this.selectedRows = event.selected;
    }
    public closeModal(){
        this.save.emit(null);
    }
    public saveproduct() {
      console.log(this.selectedRows);
      if (typeof this.selectedRows === "undefined" || this.selectedRows === null) {
        swal('Cảnh báo!', "Bạn chưa chọn phiếu chi", 'warning');
        return;
      }
      else
        this.save.emit(this.selectedRows);
    }


   

   


}
